export default __webpack_public_path__ + "locales/ro/Ldap.json?hash=8d25e989940d11e3110605d03b88a963";